import classnames from 'classnames';

import { UserProfile } from 'components/userProfile';

import { useConversationRow } from '../../../utils/useConversationRow';

import styles from './conversationsTableCustomer.module.scss';

/** Represents the content of the customer cell in the conversations table. */
export const ConversationsTableCustomer = (): JSX.Element => {
  const { conversation, density } = useConversationRow();

  const description = conversation.is_abandoned
    ? 'Abandoned'
    : conversation.subject;

  return (
    <UserProfile
      user={conversation.requested_by}
      truncateName
      description={description}
      descriptionClassName={classnames(styles.description, {
        [styles.truncated]: density === 'compact',
      })}
    />
  );
};
